import { httpRequest } from "@/utils/HttpRequest";

class RepairHistoryService {

    async repairHistory(searchVo: any) {
        const apiUrl = "/zzw-vrm/maintenance/repairHistory";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }

    async repairHistoryExport(params: any) {
        const apiUrl = "/zzw-vrm/maintenance/repairHistoryExport";
        return await httpRequest.postFile(apiUrl, params);
    }

}
export const repairHistoryService = new RepairHistoryService();
